import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";

export const RemoveUserDialog = ({ user, onClose, isOpen, onAccept }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth={true} maxWidth="csm">
      <DialogTitle
        sx={{
          marginBottom: "20px",
          padding: "32px 0 0 48px",
        }}
        className="white-to-dark"
        data-testid="form-title"
      >
        Remove shared user
      </DialogTitle>
      <DialogContent
        sx={{
          padding: "0 48px 24px",
        }}
      >
        Are you sure you want to remove
        <SoftTypography component="span" sx={{ fontWeight: 700, fontSize: "16px" }}>
          {" "}
          {user?.first_name} {user?.last_name}
        </SoftTypography>{" "}
        from this connector?
      </DialogContent>
      <DialogActions
        sx={{
          padding: "0 48px 32px",
        }}
      >
        <SoftButton variant="outlined" color="info" onClick={onClose}>
          cancel
        </SoftButton>
        <SoftButton color="primary" onClick={onAccept}>
          remove
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
};
